module.exports = __webpack_public_path__ + "public/media/office.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/office.png
// module id = ./images/partners/office.png
// module chunks = 0